import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../asset/Pink.png'; // Assuming this is the same logo used in navbar
import { FaLinkedin, FaTiktok, FaInstagram, FaYoutube, FaFolder } from 'react-icons/fa';
import { FaHome, FaInfoCircle, FaShoppingCart, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo-section">
          <Link to="/">
            <img src={logo} alt="Logo" className="footer-logo" />
          </Link>
        </div>
        
        <div className="footer-links">
          
          <div className="footer-links-column">
            <h4>Navigation</h4>
            <div className="social-icons">
              <Link to="/">
                <FaHome className="nav-icon" />
              </Link>
              <Link to="/about">
                <FaInfoCircle className="nav-icon" />
              </Link>
              <Link to="/projects">
                <FaFolder className="nav-icon" />
              </Link>
              <Link to="/contact">
                <FaEnvelope className="nav-icon" />
              </Link>
            </div>
          </div>
          
          <div className="footer-links-column">
            <h4>Connect</h4>
            <div className="social-icons">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                <FaLinkedin className="social-icon" />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">
                <FaTiktok className="social-icon" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <FaInstagram className="social-icon" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <FaYoutube className="social-icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {currentYear} All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer; 